import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
 
@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
 
  constructor(private router: Router,
    private toastr: ToastrService
  ) {}
 
  canActivate(): boolean {
    const token = localStorage.getItem('token');
 
    if (token) {
      return true;
    } else {
      this.toastr.info('Please login to continue', 'Authentication Required');
      this.router.navigate(['/auth/login']);
      return false;
    }
  }
}